import React from 'react';
import './testimonials.css';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';

const testimonials = [
  {
    name: "Rajesh Kumar",
    quote: "Exceptional villa experience! The indoor pool and movie theatre made our family vacation unforgettable. Perfect for large groups."
  },
  {
    name: "Priya Sharma",
    quote: "Beautiful property with world-class amenities. The staff was attentive and the location in Pathankot is perfect for a peaceful getaway."
  },
  {
    name: "Amit Patel",
    quote: "Luxury at its finest! The 6BHK layout is spacious and the facilities are top-notch. Highly recommend for family gatherings."
  }
];

const getInitial = (name) => name ? name.charAt(0).toUpperCase() : '?';

const TestimonialsSection = () => (
  <section className="testimonials-section">
    <h2 className="testimonials-title">TESTIMONIALS</h2>
    <p className="testimonials-desc">What Our Guests Say About Us</p>
    <div className="testimonials-grid">
      {testimonials.map((t, idx) => (
        <div className={`testimonial-card fade-in testimonial-${idx+1}`} key={t.name}>
          <div className="testimonial-avatar">
            {getInitial(t.name)}
          </div>
          <FaQuoteLeft className="testimonial-quote-icon" />
          <blockquote>“{t.quote}”</blockquote>
          <div className="testimonial-stars">
            {[...Array(5)].map((_, i) => (
              <FaStar key={i} className="testimonial-star" />
            ))}
          </div>
          <p className="testimonial-name">{t.name}</p>
        </div>
      ))}
    </div>
  </section>
);

export default TestimonialsSection; 